import EnvDetails, { ServiceURLs } from "../env_config"

export const getFileUrl = (imagePath) => {
  if (!imagePath) return "";

  // ✅ If already a full URL, return as-is
  if (/^https?:\/\//i.test(imagePath)) {
    return imagePath;
  }

  // ✅ Otherwise construct from env config
  return `${EnvDetails.getServerConfigs()}${ServiceURLs.FILE_SERVICE_PATH}/url/${imagePath}`;
};
